import { motion } from "framer-motion";
import React from "react";
import FlyingStart from "./flyingStart/FlyingStart";
import { WrapperMainCta, DivImg } from "./Main.styles";

export const CallToActionOne = () => {
  return (
    <>
      <WrapperMainCta style={{ background: "#fcfcfc" }}>
        <DivImg>
          <motion.div
            whileInView={{ x: 0, y: 0, opacity: 1 }}
            initial={{ x: "-50%", y: "-30%", opacity: 0 }}
            transition={{ duration: 2, stiffness: 1 }}
          >
            <img
              src="img/Hero section mobile mockup.png"
              alt="mobile phone screen"
            />
          </motion.div>
        </DivImg>
        <>
          <FlyingStart />
        </>
      </WrapperMainCta>
    </>
  );
};
